import { Theme } from '@mui/material';

/**
 * Modifies the provided theme to add some global style selectors.
 */
export function addGlobalStyles(theme: Theme, applicationRoot?: string) {
  // Global styles added to the CSS baseline, including the application root
  // optionally provided by the consumer
  theme.components ??= {};
  theme.components.MuiCssBaseline ??= {};
  theme.components.MuiCssBaseline.styleOverrides = {
    [`html, body${applicationRoot && `, ${applicationRoot}`}`]: {
      width: '100%',
      height: '100%',
    },
    body: {
      backgroundColor: theme.palette.background.default,
      overscrollBehavior: 'none',
    },
    a: {
      color: theme.palette.secondary.main,
      textDecoration: 'none',
      cursor: 'pointer',
    },
    'strong, b': {
      fontWeight: theme.typography.fontWeightBold,
    },
  };
}
